module.exports = __webpack_public_path__ + "img/18.102.B.a8861428.png";